<template>
  <div class="content-wrapper">
    <!-- Menu Header Here -->
    <SendGiftMenu
      header="Manage Templates"
      backTo="/shopping-bag"
      :displayShoppingBag="false"
    />

    <!-- Back Arrow Here -->
    <div class="arrow-link">
      <router-link to="/manage-templates">
        <span class="inter">Back</span>
      </router-link>
    </div>

    <!-- Form Section Here -->
    <section>
      <div class="form-holder">
        <p class="editorial uppercase">add card template</p>

        <!-- Form Here -->

        <form>
          <!-- Template Name Here -->
          <div class="form-group">
            <div class="label-holder">
              <label for="template-name">Template Name</label>
              <small>Required</small>
            </div>

            <div class="input-holder">
              <input
                type="text"
                id="template-name"
                placeholder="Template name"
                v-model="templateName"
                :class="{ input__error: $v.templateName.$error }"
              />
            </div>
          </div>

          <!-- Template Message -->
          <div class="form-group">
            <div class="label-holder text-area">
              <label for="template-message">Message</label>
              <small>Required</small>
            </div>

            <div class="input-holder text-area">
              <textarea
                id="template-message"
                :maxlength="maxCharacters"
                cols="30"
                rows="10"
                placeholder="Type card message"
                v-model="message"
                :class="{ input__error: $v.message.$error }"
              ></textarea>

              <small class="text-right">
                {{
                  `${charactersLeft} ${
                    charactersLeft == 1 ? 'character' : 'characters'
                  }  left`
                }}
              </small>
            </div>
          </div>

          <!-- Button Here -->
          <div class="flex justify-end button-region">
            <button
              type="button"
              class="button-gemnote button-gemnote--small"
              :disabled="disabledButton"
              @click="handleTemplate"
            >
              <span>Save</span>
            </button>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import SendGiftMenu from '@/components/SendGiftMenu'
import { mapState, mapGetters } from 'vuex'
import { required, maxLength } from 'vuelidate/lib/validators'
export default {
  name: 'NewCardTemplates',

  components: {
    SendGiftMenu
  },

  data: () => ({
    templateName: ''
  }),

  validations: {
    templateName: { required },
    message: { required, maxLength: maxLength(500) }
  },

  computed: {
    ...mapGetters('order', ['charactersLeft']),
    ...mapState({
      maxCharacters: state => state.order.maxCharacters,
      isTemplateSaving: state => state.cardTemplate.isTemplateSaving
    }),

    disabledButton() {
      return !this.message || !this.templateName || this.isTemplateSaving
    },

    message: {
      get() {
        return this.$store.state.order.cardMessage
      },
      set(value) {
        this.$store.dispatch('order/setCardMessage', value)
      }
    }
  },

  methods: {
    async handleTemplate() {
      this.$v.$touch()
      if (this.$v.$error === true) {
        return
      }

      await this.$store.dispatch('cardTemplate/addCardTemplate', {
        name: this.templateName,
        message: this.message
      })
      this.$store.dispatch('order/setCardMessage', '')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

section {
  margin-top: 3rem;

  .form-holder {
    border: 1px solid #232220;
    padding: 1.5rem;
    text-align: left;

    form {
      margin-top: 2rem;

      .form-group {
        display: flex;
        margin-bottom: 2.5rem;

        .label-holder {
          margin-top: 5px;
          width: 17%;
          align-self: center;
          position: relative;

          &.text-area {
            align-self: auto;
          }

          label {
            font-size: 0.875rem;
            font-weight: bold;
            margin-bottom: -5px;
          }

          small {
            color: rgba(35, 34, 32, 0.5);
            font-size: 0.625rem;
            position: absolute;
            left: 0;
            top: 22px;
          }
        }

        .input-holder {
          width: 30%;

          &.text-area {
            width: 65%;
            position: relative;

            small {
              font-size: 0.625rem;
              line-height: 12px;
              color: #a09c95;
              float: right;
            }
          }

          input {
            font-size: 0.875rem;

            &.input__error {
              border-bottom: 1px solid $gem-terraorange;
            }

            &::placeholder {
              color: #a09c95;
              font-weight: normal;
              font-size: 0.75rem;
            }
          }

          textarea {
            border: 1px solid #a09c95;
            background: inherit;
            resize: none;
            padding: 12px;
            font-size: 0.875rem;

            &.input__error {
              border: 1px solid $gem-terraorange;
            }

            &::placeholder {
              color: #a09c95;
              font-weight: normal;
              font-size: 0.75rem;
            }
          }
        }
      }

      .button-region {
        margin-bottom: 0.75rem;
        margin-right: 1.5rem;

        .button-gemnote--small {
          width: auto;
          padding: 0 1.5rem;
          height: 2.5rem;

          &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }
        }
      }
    }
  }
}
</style>
